export const KeyboardKeys = {
    // Modifier keys
    "Alt": 'Alt',
    "AltGraph": 'AltGraph',
    "CapsLock": 'CapsLock',
    "Control": 'Control',
    "Meta": "Meta",
    "Fn": 'Fn',
    "FnLock": 'FnLock',
    "NumLock": 'NumLock',
    "ScrollLock": 'ScrollLock',
    "Shift": 'Shift',
    "Symbol": 'Symbol',
    "SymbolLock": 'SymbolLock',
    "Dot": ".",

    // Navigation keys
    "ArrowDown": 'ArrowDown',
    "ArrowLeft": 'ArrowLeft',
    "ArrowRight": 'ArrowRight',
    "ArrowUp": 'ArrowUp',
    "End": 'End',
    "Home": 'Home',
    "PageDown": 'PageDown',
    "PageUp": 'PageUp',

    // Editing keys
    "Backspace": 'Backspace',
    "Clear": 'Clear',
    "Copy": 'Copy',
    "CrSel": 'CrSel',
    "Cut": 'Cut',
    "Delete": 'Delete',
    "EraseEof": 'EraseEof',
    "ExSel": 'ExSel',
    "Insert": 'Insert',
    "Paste": 'Paste',
    "Redo": 'Redo',
    "Undo": 'Undo',

    // Number keys
    "0": '0',
    "1": '1',
    "2": '2',
    "3": '3',
    "4": '4',
    "5": '5',
    "6": '6',
    "7": '7',
    "8": '8',
    "9": '9',

    // Function keys
    "F1": 'F1',
    "F2": 'F2',
    "F3": 'F3',
    "F4": 'F4',
    "F5": 'F5',
    "F6": 'F6',
    "F7": 'F7',
    "F8": 'F8',
    "F9": 'F9',
    "F10": 'F10',
    "F11": 'F11',
    "F12": 'F12',

    // Letter keys
    "A": 'A',
    "B": 'B',
    "C": 'C',
    "D": 'D',
    "E": 'E',
    "F": 'F',
    "G": 'G',
    "H": 'H',
    "I": 'I',
    "J": 'J',
    "K": 'K',
    "L": 'L',
    "M": 'M',
    "N": 'N',
    "O": 'O',
    "P": 'P',
    "Q": 'Q',
    "R": 'R',
    "S": 'S',
    "T": 'T',
    "U": 'U',
    "V": 'V',
    "W": 'W',
    "X": 'X',
    "Y": 'Y',
    "Z": 'Z',

    // Other keys
    "Enter": 'Enter',
    "Escape": 'Escape',
    "Space": ' ',
    "Tab": 'Tab',
    "Unidentified": 'Unidentified',
};

export const KeyboardShortcuts = {
    project: {
        create: KeyboardKeys.N,
        edit: KeyboardKeys.F2,
        delete: KeyboardKeys.Delete
    },
    userStory: {
        create: KeyboardKeys.N,
        save: `${KeyboardKeys.Shift}+${KeyboardKeys.S}`,
        discard: `${KeyboardKeys.Escape}`,
    },
    useCase: {
        create: KeyboardKeys.N,
        save: `${KeyboardKeys.Shift}+${KeyboardKeys.S}`,
        discard: `${KeyboardKeys.Escape}`,
    },
    testCase: {
        create: KeyboardKeys.N,
        save: `${KeyboardKeys.Shift}+${KeyboardKeys.S}`,
        discard: `${KeyboardKeys.Escape}`,
    },
    folder: {
        create: `${KeyboardKeys.Control}+${KeyboardKeys.Shift}+${KeyboardKeys.F}`,
        createRoot: `${KeyboardKeys.Control}+${KeyboardKeys.Shift}+${KeyboardKeys.H}`,
        edit: KeyboardKeys.F2,
        delete: KeyboardKeys.Delete
    },
    header: {
        search: KeyboardKeys.S,
        toggleSidebar: `${KeyboardKeys.Alt}+${KeyboardKeys.S}`,
    },
    ai: {
        generate: `${KeyboardKeys.Alt}+${KeyboardKeys.G}`,
        toggle: `${KeyboardKeys.Alt}+${KeyboardKeys.O}`  
    },
    pages : {
        userStory: `${KeyboardKeys.U}+${KeyboardKeys.S}`,
        useCase: `${KeyboardKeys.U}+${KeyboardKeys.C}`,
        testCase: `${KeyboardKeys.T}+${KeyboardKeys.C}`,
        planning: `${KeyboardKeys.P}+${KeyboardKeys.L}`,
        execution: `${KeyboardKeys.E}+${KeyboardKeys.X}`,
        dashboard: `${KeyboardKeys.D}+${KeyboardKeys.A}`,
        task: `${KeyboardKeys.T}+${KeyboardKeys.A}`,
        project: `${KeyboardKeys.P}+${KeyboardKeys.R}`,
        programme: `${KeyboardKeys.P}+${KeyboardKeys.G}`,
        department: `${KeyboardKeys.D}+${KeyboardKeys.E}`,
        organisations: `${KeyboardKeys.O}+${KeyboardKeys.R}`,
        home: `${KeyboardKeys.H}+${KeyboardKeys.O}`,
    }
}

